module.exports = __webpack_public_path__ + "static/DHB-59d86d9a675589eec8214b155e1aebec.png";